var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipetteRack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 227,
    height: 262,
    fill: "none",
    viewBox: "0 0 227 262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 253.744,
    x: 4,
    fill: "#D9D9D9",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.274,
    height: 27.135,
    fill: "#D9D9D9",
    rx: 5,
    transform: "matrix(.51056 .85984 -.872 .4895 28.092 233.343)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.274,
    height: 27.135,
    fill: "#D9D9D9",
    rx: 5,
    transform: "matrix(-.51056 .85984 -.872 -.48951 223 246.626)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.76,
    height: 253.744,
    x: 214.24,
    fill: "#D9D9D9",
    rx: 4.38
  }), /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 43,
    x: 10,
    y: 25.745,
    fill: "#99B2C4",
    rx: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 227,
    height: 261.744,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipetteRack);
export default __webpack_public_path__ + "static/media/PipetteRack.721c5b5e8d439301559b5947b704dbe8.svg";
export { ForwardRef as ReactComponent };